import { render, staticRenderFns } from "./OccupyOrderExpend.vue?vue&type=template&id=88ac4540&scoped=true"
import script from "./OccupyOrderExpend.vue?vue&type=script&lang=js"
export * from "./OccupyOrderExpend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88ac4540",
  null
  
)

export default component.exports